import { createCommand } from '../../utils';
import { moduleName, tagsInitialized } from '../state';

export const InitTagsgsCommand = createCommand(`${moduleName}/INIT_TAGS`, async (_, { dispatch, extra }) => {
    const tags = await extra.externalTags.loadTags();

    dispatch(tagsInitialized(tags));
});
